



import RegisterMobile from '../sections/register/template_01';




import "./style.css";

const RegisterPage = ()=>{
return (
<div id="registerPage" className="page">
  
  

  
  <RegisterMobile desktopTitleToggle={ true }
    mobileTitleToggle={ true } birthdayReminder={ true } />
  
  
  
</div>
)
}

export default RegisterPage;